import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {apiClient} from "../connection/BlinkApiClient";
import {Currency} from "../../stem-core/localization/CurrencyStore";
import {field} from "../../stem-core/state/StoreField";

@globalStore
export class UserPreferences extends BaseStore("UserPreferences") {
    // All of api/users/models.py UserPreferences. The last four are set by the server only, the rest
    // are what update_user_preferences takes back
    @field(Boolean) showOnboarding: boolean;
    @field(Number) userId: number;
    @field(Number) defaultCurrencyId: number;
    @field(Boolean) alwaysShowBalance: boolean;
    @field(Boolean) showPaymentAnimation: boolean;
    @field(Boolean) autoPayEnabled: boolean;
    @field(Boolean) autoTopUpEnabled: boolean;
    @field(Number) articlePriceLimit: number;
    @field(Number) autoTopUpAmount: number;
    @field(Number) autoTopUpThreshold: number;
    @field(Number) maxWalletBalance: number;
    @field(Number) topUpDailyLimit: number;
    @field(Number) topUpMonthlyLimit: number;

    getDefaultCurrency(): Currency | undefined {
        return Currency.get(this.defaultCurrencyId);
    }

    shouldShowBalanceInline(): boolean {
        return this.alwaysShowBalance;
    }

    shouldShowPaymentAnimation(): boolean {
        return this.showPaymentAnimation;
    }

    static getPreferences(): UserPreferences | undefined {
        return this.all()[0];
    }
}

export async function apiUpdatePreferences(preferences: any = {}): Promise<UserPreferences> {
    const response = await apiClient.post("/preferences/update_user_preferences", preferences);
    return UserPreferences.loadObject(response);
}
